import * as React from 'react';

import Button from '@components/Button';
import Input from '@components/Input';
import ModalBase from '@components/ModalBase';

import { getEmptyErrorState } from '@utils/AppUtil';
import CyberdyneValidator from '@utils/cyberdyneValidator';
import ErrorMessageGenerator from '@utils/ErrorMessageGenerator';

export interface IDefaultCityModalProps {
  show: boolean;
  defaultCity: string;
  onClose: (e: React.SyntheticEvent<any>) => void;
  onSubmit: (defaultCity: string) => (e: React.SyntheticEvent<HTMLButtonElement>) => void;
}

interface IDefaultCityModalState {
  defaultCity: string;
  error: {
    defaultCity: IFieldValidation;
  };
}

const errMsgGen = new ErrorMessageGenerator();
const cyberdyneValidator = new CyberdyneValidator();

class DefaultCityModal extends React.Component<IDefaultCityModalProps, IDefaultCityModalState> {
  constructor(props: IDefaultCityModalProps) {
    super(props);

    this.state = this.getEmptyState();
  }

  componentDidUpdate(prevProps: IDefaultCityModalProps) {
    if (prevProps.show !== this.props.show && this.props.show) {
      this.setState(this.getEmptyState());
    }
  }

  getEmptyState = (): IDefaultCityModalState => ({
    defaultCity: this.props.defaultCity || '',
    error: {
      defaultCity: getEmptyErrorState(),
    },
  });

  validateForm = () => {
    let isValid = true;
    const defaultCity = (this.state.defaultCity || '').trim();
    const { error } = this.getEmptyState();

    if (cyberdyneValidator.isEmptyValue(defaultCity)) {
      error.defaultCity = {
        errorState: IValidationState.ERROR,
        errorMessage: errMsgGen.getMandatoryFieldMessage('Default City'),
      };

      isValid = false;
    } else if (cyberdyneValidator.isStringGreaterThanLength(defaultCity, 50)) {
      error.defaultCity = {
        errorState: IValidationState.ERROR,
        errorMessage: errMsgGen.getCharacterLimitMessage('Default City', 50),
      };

      isValid = false;
    }

    this.setState({ error });

    return isValid;
  };

  onSubmit = (e: React.SyntheticEvent<HTMLButtonElement>) => {
    if (this.validateForm()) {
      const defaultCity = this.state.defaultCity.trim();
      this.props.onSubmit(defaultCity)(e);
    }
  };

  handleChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
    const { name, value } = e.currentTarget;
    this.setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  renderTitle = () => (this.props.defaultCity ? 'Edit Default City' : 'Default City');

  renderDefaultCityField = () => (
    <Input
      field={{
        label: 'Default City',
        type: CustomFieldType.TEXT,
        isRequired: true,
        value: this.state.defaultCity || '',
      }}
      error={this.state.error.defaultCity}
      width={4}
      name="defaultCity"
      onChange={this.handleChange}
    />
  );

  renderBody = () => <div className="default-city__body">{this.renderDefaultCityField()}</div>;

  renderFooter = () => {
    const submitBtnTxt = this.props.defaultCity ? 'Save' : 'Add Default City';

    return (
      <div className="default-city__footer">
        <Button bsStyle={ButtonStyle.DEFAULT} onClick={this.props.onClose} content="Cancel" />
        <Button bsStyle={ButtonStyle.PRIMARY} onClick={this.onSubmit} content={submitBtnTxt} />
      </div>
    );
  };

  render() {
    return (
      <ModalBase
        show={this.props.show}
        onClose={this.props.onClose}
        titleElement={this.renderTitle()}
        bodyElement={this.renderBody()}
        footerElement={this.renderFooter()}
        className="default-city-modal"
      />
    );
  }
}

export default DefaultCityModal;
